export default "__VITE_ASSET__8132df36__"